import { api, type FetchOptions } from './client';
import type { Tenant, APISubscribedSku } from '../types';

export const tenantsApi = {
  list: () => api.get<Tenant[]>('/tenants'),
  get: (id: string) => api.get<Tenant>(`/tenants/${id}`),
  create: (data: { id: string; display_name: string; default_domain?: string | undefined }) =>
    api.post<Tenant>('/tenants', data),
  delete: (id: string) => api.delete<null>(`/tenants/${id}`),
  health: (id: string) => api.get<unknown>(`/tenants/${id}/health`),
  /** The licences this tenant owns — the source for every licence picker. */
  subscribedSkus: (id: string, opts?: FetchOptions) =>
    api.getCached<APISubscribedSku[]>(`/tenants/${id}/subscribed-skus`, opts),
};
